"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _EverdaysLogoWhite2x = _interopRequireDefault(require("../images/Everdays-Logo-(white)@2x.png"));

var _facebook = _interopRequireDefault(require("../images/facebook.svg"));

var _twitter = _interopRequireDefault(require("../images/twitter.svg"));

var _instagram = _interopRequireDefault(require("../images/instagram.svg"));

var _linkedin = _interopRequireDefault(require("../images/linkedin.svg"));

require("../sass/containers/LoginContainer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(_ref) {
  var children = _ref.children,
      content = _ref.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "login-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "left-container",
    style: content && content.styles
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "self-start",
    href: "/"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _EverdaysLogoWhite2x.default,
    alt: "logo",
    className: "logo"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "right-container"
  }, children));
};

exports.default = _default;